import { EarlyBirdForm } from "@/api/dtos";
import useEarlyBirdInvoice from "@/hooks/useEarlyBirdInvoice";
import { Container, Backdrop, CircularProgress, Box } from "@mui/material";
import React, { useState } from "react";

interface InvoiceProps {
    earlyBirdForm: EarlyBirdForm
}

const EarlyBirdInvoice = React.forwardRef(({ earlyBirdForm }: InvoiceProps, ref) => {
    const  {invoice, loading} = useEarlyBirdInvoice(earlyBirdForm.registrationId)

    const [displayInvoice, setDisplayInvoice] = useState<string>();
    React.useEffect(() => {
        if(!displayInvoice){
            setDisplayInvoice(invoice);
        }
    }, [invoice, loading]);

    return (
        <Container
            maxWidth="lg"
        >
            {
                loading ? 
                    <Backdrop
                        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                        open={true}
                    >
                        <CircularProgress color="inherit" />
                    </Backdrop>
                :
                displayInvoice && (
                    <Box
                        ref={ref}
                        sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            mt: 4
                        }}
                        dangerouslySetInnerHTML={{ __html: displayInvoice }}
                    />
                )
            }
        </Container>
    );
})

export default EarlyBirdInvoice;